
export class VNPay_Response {
  TransactionCode: string;
  RefCode: string;
  MaHTTT: string;
  status: number;
}

export class App_Response {
  Data: string;  
}


export class Voucher {
  MaPhieu: string;
  DaSuDung: boolean;
  MaHDSuDung: string;
  NgaySuDung: Date;
  LoaiThanhToan: number;
  HieuLucTuNgay: Date;
  HieuLucDenNgay: Date;
  MaKhSuDung: string;
  MaHD: string;
  TriGiaThanhToan: number;
  TyLeThanhToan: number;
}


export class ListVoucher {
  vouchers: Voucher;
  hdID: string;
  MaKHTV?: string;
  STTHD?: number;
  MaQuay: string;
}


export class MomoQR {
  MerchantID: string;
  MaCH: string;
  TenCH: string;
  URLTT: string;
  URLCheck: string;
  Publickey: any;
}

export class Momo_Message {
  transid: number;
  description: string;
  amount: number;
  phoneNumber: string;
  self_status?: number;
  data?: object;
  message?: string;
}


export class Momo_Query_Message {
  status: number;
  message: string;
  billid: string;
  transid: number;
  amount: number;
}


export class VNPay_Message {
  transid: number;
  description: string;
  amount: number;
  phoneNumber: string;
  self_status?: number;
  data?: object;
  message?: string;
}


export class VNPay_Query_Message {
  status: number;
  message: string;
  billid: string;
  transid: string;
  amount: number;
}



// WEBPACK FOOTER //
// ./src/app/models/payment.model.ts